import { render, staticRenderFns } from "./SuppressionRemove.vue?vue&type=template&id=635ec6f9"
import script from "./SuppressionRemove.vue?vue&type=script&lang=js"
export * from "./SuppressionRemove.vue?vue&type=script&lang=js"
import style0 from "./SuppressionRemove.vue?vue&type=style&index=0&id=635ec6f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports